module.exports = __webpack_public_path__ + "img/ill-home-services-web-applications.1f3e3e36.svg";